<!-- Popup Content -->
<!-- <div *ngIf="selectedPolicyMovement" nxModal> -->
<div *ngIf="popup_type === 'policyTable'">
    <h3 nxHeadline="subsection-medium" class="nx-margin-bottom-s">Policy Movement</h3>
    <div nxModalContent>
        <div class="left-content">
            <h4 nxHeadline="subsection-xsmall" class="nx-margin-bottom-m popup_blue_title nx-font-weight-semibold">
                Endorsement Details
            </h4>
            <div nxLayout="grid nopadding">
                <div nxRow>
                    <div nxCol="12,12,6" class="nx-margin-bottom-m">
                        <nx-data-display size="small">
                            <nx-data-display-label class="font-grey">Endorsement No.</nx-data-display-label>
                            <p nxCopytext="large">{{ selectedPolicyMovement.transactionNo }}</p>
                        </nx-data-display>
                    </div>
                    <div nxCol="12,12,6" class="nx-margin-bottom-m">
                        <nx-data-display size="small">
                            <nx-data-display-label class="font-grey">Endorsement Type</nx-data-display-label>
                            <p nxCopytext="large">{{ selectedPolicyMovement.endorsementDesc }}</p>
                        </nx-data-display>
                    </div>
                </div>
                <div nxRow>
                    <div nxCol="12,12,6" class="nx-margin-bottom-m">
                        <nx-data-display size="small">
                            <nx-data-display-label class="font-grey">Issue Date</nx-data-display-label>
                            <!-- to check if data exists -->
                            <p nxCopytext="large">{{ selectedPolicyMovement.cnoteDate }}</p>
                        </nx-data-display>
                    </div>
                    <div nxCol="12,12,6" class="nx-margin-bottom-m">
                        <nx-data-display size="small">
                            <nx-data-display-label class="font-grey">Issue By</nx-data-display-label>
                            <p nxCopytext="large">{{ selectedPolicyMovement.issueBy }}</p>
                        </nx-data-display>
                    </div>
                </div>
                <div nxRow>
                    <div nxCol="12,12,6">
                        <nx-data-display size="small" class="nx-margin-bottom-30">
                            <nx-data-display-label class="font-grey">Gross Premium (RM)</nx-data-display-label>
                            <p nxCopytext="large">{{ selectedPolicyMovement.grossPremium }}</p>
                        </nx-data-display>
                    </div>
                </div>
                <div nxRow>
                    <hr />
                </div>
            </div>
            <hr class="nx-margin-bottom-m" />
            <h4 nxHeadline="subsection-xsmall" class="nx-margin-bottom-m popup_blue_title nx-font-weight-semibold">
                Endorsement Narration
            </h4>

            <div [innerHTML]="safeNarration" class="narration-content"></div>
             
            <div class="nx-margin-top-l">
                <button nxButton="secondary" nxModalClose>Close</button>
            </div>
        </div>
    </div>
</div>